import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyStateStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={52}
    height={52}
    fill="none"
    viewBox="0 0 52 52"
    {...props}
  >
    <path
      fill="#E6ECF4"
      d="M24.645 2.574a1.873 1.873 0 0 1 2.698 0l3.072 3.189c.481.5 1.2.692 1.867.5l4.254-1.225a1.873 1.873 0 0 1 2.337 1.349l1.066 4.298c.167.674.693 1.2 1.367 1.367l4.296 1.066a1.874 1.874 0 0 1 1.35 2.338l-1.226 4.255c-.192.667 0 1.386.5 1.867l3.189 3.073a1.874 1.874 0 0 1 0 2.698l-3.188 3.073c-.5.481-.693 1.2-.5 1.868l1.224 4.255a1.874 1.874 0 0 1-1.349 2.337l-4.296 1.066c-.674.167-1.2.694-1.367 1.367l-1.066 4.298a1.873 1.873 0 0 1-2.337 1.35l-4.254-1.226a1.87 1.87 0 0 0-1.867.5l-3.072 3.19a1.873 1.873 0 0 1-2.698 0l-3.071-3.19c-.482-.5-1.2-.692-1.868-.5l-4.254 1.225a1.873 1.873 0 0 1-2.336-1.349l-1.066-4.298a1.87 1.87 0 0 0-1.368-1.367l-4.296-1.066a1.874 1.874 0 0 1-1.35-2.337l1.226-4.255c.192-.668 0-1.387-.5-1.868l-3.188-3.073a1.874 1.874 0 0 1 0-2.698l3.188-3.073c.5-.481.692-1.2.5-1.867l-1.225-4.255a1.874 1.874 0 0 1 1.349-2.338l4.296-1.066a1.87 1.87 0 0 0 1.368-1.367l1.066-4.298a1.873 1.873 0 0 1 2.336-1.35l4.254 1.226c.667.192 1.386 0 1.868-.5z"
    />
    <path
      stroke="#26368A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M24.657 2.574a1.873 1.873 0 0 1 2.698 0l3.071 3.189c.482.5 1.2.692 1.868.5l4.254-1.225a1.873 1.873 0 0 1 2.337 1.349l1.065 4.298c.167.674.694 1.2 1.367 1.367l4.297 1.066a1.874 1.874 0 0 1 1.35 2.338l-1.226 4.255c-.192.667 0 1.386.5 1.867l3.188 3.073a1.874 1.874 0 0 1 0 2.698l-3.188 3.073c-.5.481-.692 1.2-.5 1.868l1.225 4.255a1.874 1.874 0 0 1-1.349 2.337l-4.296 1.066c-.674.167-1.2.694-1.368 1.367l-1.065 4.298a1.873 1.873 0 0 1-2.337 1.35l-4.254-1.226a1.87 1.87 0 0 0-1.868.5l-3.071 3.19a1.873 1.873 0 0 1-2.698 0l-3.072-3.19c-.481-.5-1.2-.692-1.867-.5l-4.254 1.225a1.873 1.873 0 0 1-2.337-1.349l-1.066-4.298a1.87 1.87 0 0 0-1.367-1.367l-4.296-1.066a1.874 1.874 0 0 1-1.35-2.337l1.226-4.255c.192-.668 0-1.387-.5-1.868l-3.189-3.073a1.874 1.874 0 0 1 0-2.698l3.188-3.073c.5-.481.693-1.2.5-1.867L5.05 15.456a1.874 1.874 0 0 1 1.349-2.338l4.296-1.066a1.87 1.87 0 0 0 1.367-1.367l1.066-4.298a1.873 1.873 0 0 1 2.337-1.35l4.254 1.226c.667.192 1.386 0 1.867-.5z"
    />
    <path
      stroke="#26368A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M26.067 38.776a.936.936 0 1 0 0-1.874M19.51 20.976a6.557 6.557 0 1 1 13.113 0 6.557 6.557 0 0 1-6.556 6.558v3.747"
    />
  </svg>
);
export default SvgEmptyStateStar;
